<template>
  <ul class="plist">
    <li v-for="p in items" :key="p.slug" class="pitem">
      <CompanyLogo :src="p.logo" :photo="p.photo" />
      <div>
        <div class="t">
          <a v-if="p.url" :href="p.url" target="_blank" rel="noopener">{{ p.name }}</a>
          <template v-else>{{ p.name }}</template>
        </div>
        <div class="k">{{ t(p.kind) }}</div>
      </div>
      <span :class="['badge', p.badgeClass]">{{ t(p.badge) }}</span>
      <p>{{ t(p.text) }}</p>
    </li>
  </ul>
</template>

<script>
import CompanyLogo from "./Logo.vue";
import { useI18n } from "@/i18n";

export default {
  name: "ProjectList",
  components: { CompanyLogo },
  props: { items: { type: Array, required: true } },
  setup: () => useI18n(),
};
</script>

<style scoped>
.plist {
  list-style: none;
}
</style>
